import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0,
  GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0,
  GET_ALL_THERAPY_TEMPLATES_LOADING_2_0,
  GET_ALL_THERAPY_TEMPLATES_RESET_2_0,
  GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0,
} = therapyPlanningAction;

const intitialstate: any = {
  response: null,
  loading: false,
  isGetAllTemplates: false,
  currentPage: -1,
  pageNumber: 0,
  totalTemplates: [],
};

export const getAllTherapyPlaningTemplatesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          isGetAllTemplates: true,
          totalTemplates: [...state.totalTemplates, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          response: action.payload,
          loading: false,
          isGetAllTemplates: true,
          currentPage: newPageNumber,
          totalTemplates: action.payload?.data?.content || [],
        };
      }
    }

    case GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetAllTemplates: false,
      };

    case GET_ALL_THERAPY_TEMPLATES_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_THERAPY_TEMPLATES_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
